import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsViewsByContentQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsViewsByContentTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [limit, setLimit] = useState(10);

  const { data, loading, error } = useAnalyticsViewsByContentQuery({
    variables: { filter: filter as never, limit },
  });

  const rows = (data?.analyticsViews.viewsByContent ?? []).map((row) => [
    row.title,
    formatNumber(row.views),
    formatNumber(row.visitors),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.views.tableByContent")}
      columns={[
        { name: t("analytics.views.columnContent"), minWidth: 200 },
        { name: t("analytics.views.columnViews") },
        { name: t("analytics.views.columnVisitors") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      limit={limit}
      setLimit={setLimit}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.ViewsByContentType}
          filter={filter}
        />
      }
    />
  );
};
